import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';
import { AppState } from '../../global/types';
import { AdminState } from './types';

const initialState: AdminState = {
  sourcesData: {
    data: null,
    loading: false,
    error: null,
  },
  disableReasonsData: {
    data: null,
    loading: false,
    error: null,
  },
};

const reducer = createReducer(initialState, {
  [actions.getSources.REQUEST]: (state) => {
    state.sourcesData.loading = true;
  },
  [actions.getSources.ERROR]: (state, action) => {
    state.sourcesData.error = action.payload;
    state.sourcesData.loading = false;
  },
  [actions.getSources.SUCCESS]: (state, action) => {
    state.sourcesData.data = action.payload;
    state.sourcesData.loading = false;
  },
  [actions.getDisableReasons.REQUEST]: (state) => {
    state.disableReasonsData.loading = true;
  },
  [actions.getDisableReasons.SUCCESS]: (state, action) => {
    state.disableReasonsData.data = action.payload;
    state.disableReasonsData.loading = false;
  },
  [actions.getDisableReasons.ERROR]: (state, action) => {
    state.disableReasonsData.error = action.payload;
    state.disableReasonsData.loading = false;
  },
});

const sourcesData = (state: AppState) =>
  state.adminPageReducer.sourcesData.data;

const sourcesDLoading = (state: AppState) =>
  state.adminPageReducer.sourcesData.loading;

const tags = (state: AppState) => state.productsPageReducer.tagsData.data;

const disableReasons = (state: AppState) =>
  state.adminPageReducer.disableReasonsData.data;

const selectors = {
  sourcesData,
  sourcesDLoading,
  tags,
  disableReasons,
};

export { selectors };
export default reducer;
